/*
	Generated on 10/05/2025 by UI Generator PRICES-IDE
	https://amanah.cs.ui.ac.id/research/ifml-regen
	version 3.10.0
*/
import RequireAuth from '@/commons/auth/RequireAuth'

import DaftarRuanganPage from './containers/DaftarRuanganPage'
import DetailRuanganPage from './containers/DetailRuanganPage'
import TambahRuanganPage from './containers/TambahRuanganPage'
import UbahRuanganPage from './containers/UbahRuanganPage'

const ruanganRoutes = [
{ 
	path: "/ruangan",
	element: <RequireAuth permissionNeeded="ReadRuangan" ><DaftarRuanganPage/></RequireAuth>
}

	
,
{ 
	path: "/ruangan/tambah",
	element: <RequireAuth permissionNeeded="SaveRuangan" ><TambahRuanganPage/></RequireAuth>
}

	
,
{ 
	path: "/ruangan/ubah",
	element: <RequireAuth permissionNeeded="UpdateRuangan" ><UbahRuanganPage/></RequireAuth>
}

	
,
{ 
	path: "/ruangan/:id",
	element: <RequireAuth permissionNeeded="ReadRuangan" ><DetailRuanganPage/></RequireAuth>
}

	

]

export default ruanganRoutes
